export class MobileAttribute {
    private static mobileReg = new RegExp(/^((\(?\+45\)?)?)(\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2})$/);
    public static hasError(value: string): boolean {
        if (!this.mobileReg.test(value)) {
            return true;
        }
        return false;
    }

    public static getErrorMessage(): string {
        return "Indtast et gyldigt telefonnummer";
    }
}